import api from "../utils/api"

export const user_login_history_api_iAmActive = async () => {
  return await api().post(`/api/iAmActive`)
}

export const user_login_history_api_iAmInActive = async () => {
  return await api().post(`/api/iAmInActive`)
}
